import React from 'react'
import { BASE_URL, RULES_FOR_BUYERS_ROUTE, RULES_FOR_SELLERS_ROUTE, SUPPORT_EMAIL } from '../../utils/consts'

const RulesForSellers = () => {
	return (
		<div className='container'>
			<h1 className='text-xl md:text-2xl'>Правила размещения объявлений</h1>

			<p className='mt-10'>
				Общество с ограниченной ответственностью «ГИР СТОР» (ООО «ГИР СТОР», ИНН 3300013334)
				является владельцем и правообладателем сайта {' '}
				<a className='link' href={BASE_URL}>
					{BASE_URL}
				</a>{' '}
				(далее – Платформа) и предоставляет возможность размещать на Платформе объявления
				о продаже запасных частей/комплектующих к автомобилям (далее – запчасти, товар).
				Настоящие Правила в силу статьи 428 ГК РФ являются условиями договора присоединения по оказанию услуг
				на Платформе. При этом, Правила не являются публичным договором.
				В случае нарушения установленных правил или лицензионного соглашения, размещенного на сайте, администрация
				Платформы может отклонить или удалить объявления, размещенные пользователями, заблокировать личный кабинет
				пользователя. При этом пользователи самостоятельно несут ответственность за допущенные ими нарушения
				законодательства и прав третьих лиц. Администрация Платформы оставляет за собой право заключать,
				не заключать или расторгнуть в любое время настоящий договор с любым пользователем без объяснения причин.
				Настоящие Правила одинаково распространяются как на бесплатные, так и на платные объявления.
				Настоящие Правила могут быть изменены и/или дополнены администрацией Платформы в одностороннем
				порядке без какого-либо специального уведомления. Настоящие Правила являются открытым и
				общедоступным документом. Действующая редакция Правил располагается в сети Интернет по адресу:&nbsp;
				{BASE_URL}
				{RULES_FOR_SELLERS_ROUTE}. Пользователям рекомендуется регулярно проверять
				условия настоящих Правил на предмет их изменения и/или дополнения. Продолжение
				использования сайта пользователем после внесения изменений и/или дополнений
				в настоящие Правила означает принятие и согласие Пользователя с
				такими изменениями и/или дополнениями.
				Если размещение объявлений пользователей явилось основанием для предъявления
				к администрации/владельцу Платформы претензий, исков третьих лиц и/или предписаний
				по уплате штрафных санкций со стороны государственных органов в связи с нарушением
				прав третьих лиц и/или действующего законодательства, пользователь обязуется незамедлительно
				предоставить администрации Платформы всю запрашиваемую информацию, касающуюся размещения
				и содержания публикаций, от своего имени урегулировать, содействовать в урегулировании
				таких претензий и исков, а также возместить все убытки, причиненные Платформе, ее
				владельцу вследствие предъявления таких претензий, исков, предписаний.
			</p>

			<h2 className='mt-5 text-xl font-bold'>1. Термины и определения</h2>
			<ul className='mt-3'>
				<li>
					1.1. Сайт, Платформа — объект интеллектуальной собственности, представляющий собой
					совокупность программ ЭВМ, веб-страниц, баз данных, фото и видео, графических и
					текстовых элементов, находящийся на сервере правообладателя и доступный для
					использования по адресу{' '}
					<a className='link' href={BASE_URL}>
						{BASE_URL}
					</a>
				</li>
				<li>
					1.2. Объявление — размещенные на Платформе данные о Товаре, его технических
					и иных характеристиках, а также о Продавце.
				</li>
				<li>
					1.3. Товар – предлагаемые к продаже путем размещения объявления на Платформе запасные
					части/комплектующие к автомобилям.
				</li>
				1.4.	Продавец – любое физическое дееспособное лицо, достигшее возраста 18 лет, юридическое
				 лицо или индивидуальный предприниматель, являющийся пользователем Платформы и предлагающий к продаже путем размещения объявления на Платформе Товар.
				<li>
					1.5. Покупатель – любое физическое дееспособное лицо, достигшее возраста 18 лет, юридическое
					 лицо или индивидуальный предприниматель, являющийся пользователем Платформы и желающее приобрести или приобретающее Товар, объявление о котором размещено на Платформе.
				</li>
				<li>
					1.6. Личный кабинет — совокупность данных о Продавца (id, телефон, пароль и т.п.), объединенных
					 с пользовательским интерфейсом, балансом личного кабинета, историей использования Платформы
					  и платежным инструментом. Доступ к Личному кабинету осуществляется по логину и паролю.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>2. Правила регистрации </h2>
			<ul className='mt-3'>
				<li>
					2.1. Для возможности размещения объявления на Платформе пользователю необходимо
					 заполнить всю предлагаемую соответствующей формой информацию для регистрации Личного кабинета.
				</li>
				<li>
					2.2. При регистрации личного кабинета контактная информация о владельце Личного
					 кабинета должна соответствовать действительности.
				</li>
				<li>
					2.3. Личный кабинет, используемый для размещения объявлений от имени юридического
					 лица, должен быть зарегистрирован на юридическое лицо, а не на имя руководителя
					  или иное физическое лицо. При отказе в публикации объявления или в предоставлении доступа к Платформе, претензии к администрации Платформы принимаются только от лица (физического или юридического), на имя которого зарегистрирован Личный кабинет.
				</li>
				<li>
					2.4. Нарушение правил о регистрации Личного кабинета, используемого для размещения
					 объявлений от имени юридического лица, либо публикация недостоверных и/или недобросовестных
					  объявлений влечет прекращение доступа юридического лица к Платформе (блокирование
					   доступа в личный кабинет).
				</li>
				<li>
					2.5. Зарегистрировавшись на сайте, пользователь автоматически соглашается на обработку
					 своих персональных данных. Платформа обязуется не предоставлять персональные данные
					  третьим лицам кроме случаев, предусмотренных действующим законодательством.
				</li>
				<li>
					2.6. Пользователь самостоятельно предоставляет/размещает на Платформе информацию о себе
					 для общего доступа всем пользователям (делает ее общедоступной).
				</li>
				<li>
					2.7. Логин пользователя не должен содержать контактные данные (номер телефона, email,
					 адрес сайта и т.д.), оскорбления, нецензурную лексику и названия, использование которых
					  в Российской Федерации запрещено.
				</li>
				<li>
					2.8. Зарегистрировавшись на сайте, пользователь автоматически соглашается на отправку
					 электронных сообщений о событиях в его кабинете на подтвержденные номера телефонов и
					  адреса электронной почты.
				</li>
				<li>
					2.9. Пользователь несет ответственность за сохранность своих учетных данных, логина и
					 пароля и обязуется не передавать их третьим лицам.
				</li>
				<li>
					2.10. Все действия на Платформе, выполненные из Личного кабинета после ввода логина и
					 пароля, считаются действиями пользователя.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>3. Правила публикации объявлений </h2>
			<ul className='mt-3'>
				<li>
					3.1. Выполняя требования к объявлениям, Продавец способствует получению правильного представления о нем как о продавце и его предложениях.
				</li>
				<li>
					3.2. Объявление должно быть опубликовано в разделе, соответствующей категории.
				</li>
				<li>
					3.3. Объявление должно содержать максимально подробные сведения о товаре.
				</li>
				<li>
					3.4. Сведения, указанные в объявлении (о товаре, о продавце), должны быть полными, достоверными и корректными. Запрещается указывать неполную, некорректную и недостоверную информацию.
				</li>
				<li>
					3.5. Сведения товаре, бывшем в употреблении, должны содержать информацию обо всех его недостатках и особенностях, отсутствии гарантийного срока. Продавец самостоятельно несет ответственность и последствия отсутствия такой информации.
				</li>
				<li>
					3.6. Продавец самостоятельно несет всю ответственность за распространение объявления, в котором отсутствуют обязательные сведения или указана недостоверная информация.
				</li>
				<li>
					3.7. Заголовок, описание и фотографии объявления должны быть связанными по смыслу и соответствовать назначению раздела. Вся информация в них должна соответствовать действующему законодательству. Продавец несет ответственность за любые нарушения законодательства или прав третьих лиц при размещении объявления.
				</li>
				<li>
					3.8. Цена, указанная в объявлении, должная быть целым числом, указанным в рублях.
				</li>
				<li>
					3.9. Цена должна соответствовать фактическому состоянию товара.
				</li>
				<li>
					3.10. Цена должна быть указана за комплект, если товар продается комплектом.
				</li>
				<li>
					3.11. Если цена может быть снижена, о такой возможности и условиях снижения должно быть указано в описании
				</li>
				<li>
					3.12. Контактная информация должна быть указана только в соответствующем поле, согласно форме подачи объявления. К контактной информации относятся: телефон, адрес электронной почты, профиль систем обмена сообщениями (whatsapp, telegram и т.д.) и адрес сайта.
				</li>
				<li>
					3.13. Заголовок объявления, фотографии, видео и логотипы не должны содержать контактных данных, ссылок на сайты и QR-коды.
				</li>
				<li>
					3.14. Фотографии не должны содержать неприятные или шокирующие кадры, а также изображения эротического и порнографического характера или иным образом нарушать требования действующего законодательства РФ к информации, размещаемой в сети Интернет.
				</li>
				<li>
					3.15. Продавец гарантирует, что фотографии, размещенные им в объявлении, не нарушают права третьих лиц на результаты интеллектуальной деятельности.
				</li>
				<li>
					3.16. Ссылки на сторонние сайты в объявлениях должны указываться корректно - без пробелов, транслитерации или иного намеренного искажения написания. Ссылка может быть указана в объявлении только до его публикации.
				</li>
				<li>
					3.17. Объявление должно быть удалено с публикации Продавцом, если товар утратил актуальность.
				</li>
				<li>
					3.18. Запрещается использовать в объявлениях ненормативную и стилизованную под ненормативную лексику, оскорбительные выражения, информацию экстремистского характера, контент эротического характера.
				</li>
				<li>
					3.19. Запрещается публиковать объявления и предлагать к продаже товар, противоречащие законодательству РФ либо нарушающие требования законодательства к информации, размещаемой в сети интернет, и/или права третьих лиц.
				</li>
				<li>
					3.20. Запрещается публиковать объявления, целью которых является обсуждение той или иной ситуации и не направленные на реализацию товара.
				</li>
				<li>
					3.21. Запрещается публиковать объявления, содержащие упоминания конкурентных Платформе ресурсов.
				</li>
				<li>
					3.22. Запрещается использовать в объявлениях любую информацию или иные условия, нарушающие законодательство Российской Федерации или права третьих лиц, либо влекущие за собой такие нарушения.
				</li>
				<li>
					3.23. Запрещается публиковать объявления о товаре с отметкой «В наличии», если товар не находится физически в месте нахождения продавца и продавец не может предоставить товар в течение одного дня.
				</li>
				<li>
					3.24. Объявления о товаре, который отсутствует в месте нахождения или который не может быть предоставлен покупателю в течение одного дня, должны публиковаться с отметкой «Под заказ».
				</li>
				<li>
					3.25. Запрещается публикация объявлений путем использования сторонних программно-технических средств.
				</li>
				<li>
					3.26. При наличии подтвержденной жалобы о том, что товара нет в наличии, указана некорректная цена либо товар продан хотя бы по одному объявлению Продавца, администрация Платформы вправе удалить все объявления Продавца с этими жалобами.
				</li>
				<li>
					3.27. Цена в специальном поле должна быть указана за единицу товара или за комплект.
				</li>
				<li>
					3.28. Главная фотография бывшего в употреблении товара не должна содержать снимки из каталогов и интернет-магазинов.
				</li>
				<li>
					3.29. В объявлении должно быть описание одной запчасти или комплекта запчастей за одну цену.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>4. Правила заказов и переписки</h2>
			<ul className='mt-3'>
				<li>
					4.1. Продавец обязан продать товар покупателю по цене из объявления на момент подтверждения заказа.
				</li>
				<li>
					4.2. Запрещаются нетематические сообщения и оскорбления в переписке. Вопросы и ответы должны касаться только дополнительного описания товара, его состояния, условий покупки или доставки.
				</li>
				<li>
					4.3. Запрещается рассылка коммерческих или иных видов сообщений (информации) лицам, не выражавшим желания их получать. Тематика сообщений должна соответствовать теме объявления.
				</li>
				<li>
					4.4. Запрещается требовать оплату или иные формы компенсации за отказ в покупке товара.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>5. Ограничения и ответственность</h2>
			<ul className='mt-3'>
				<li>
					5.1. Максимальный срок публикации в разделе — один год.
				</li>
				<li>
					5.2. Количество бесплатных объявлений одного продавца — не более 5 (пяти) штук.
				</li>
				<li>
					5.3. Размещая информацию на Платформе, пользователь передаёт исключительные права на данную информацию ООО «ГИР СТОР». ООО «ГИР СТОР» не несет никаких обязательств по обеспечению конфиденциальности в отношении этой информации.
				</li>
				<li>
					5.4. Вся информация, размещенная на Платформе, включая базу данных, тексты, фото- и видеоизображения, дизайн, подбор, группировку и расположение материалов, является интеллектуальной собственностью ООО «ГИР СТОР» и защищается нормами гражданского, административного и уголовного законодательства Российской Федерации, а также нормами международного права по охране интеллектуальной собственности.
				</li>
				<li>
					5.5. Воспроизведение и любое использование информации с Платформы разрешено только с письменного разрешения владельца Платформы. Копирование информации, содержащейся на данном сайте, может осуществляться только физическими лицами для личного пользования.
				</li>
				<li>
					5.6. Запрещается использование автоматизированного извлечения информации с Платформы без письменного разрешения ее владельца.
				</li>
				<li>
					5.7. Платформа, ее владелец не несут ответственности за полноту и достоверность информации о продавце и товаре. Данная информация заполняется Продавцами самостоятельно и под свою ответственность.
				</li>
				<li>
					5.8. Платформа не является организатором заключения договора купли-продажи между Продавцом и Покупателем, посредником, агентом или представителем какого-либо Продавца или Покупателя, и/или иным заинтересованным лицом в отношении предлагаемой/заключаемой/исполняемой между пользователями сделки или производимых расчетов.
				</li>
				<li>
					5.9. Ни при каких обстоятельствах владелец Платформы не несет ответственности за любую потерю, расходы, убытки или ущерб, (потеря деловых доходов, потеря прибыли или любой прямой, косвенный, последующий, специальный или подобный ущерб вообще), являющийся результатом: любой погрешности, содержащейся в информации, её неполноты, задержки, прерывания в получении, ошибки или упущений в поставке; любого сбоя информационной системы.
				</li>
				<li>
					5.10. При использовании Платформы, в том числе при общении в чатах не допускается размещение или передача любой информации, которая нарушает или может нарушать авторские и смежные права третьих лиц, носить угрожающий характер, быть ложной, обманчивой, подстрекательской, клеветнической, нарушающей конфиденциальность, нецензурной, порнографической, оскорбительной, дискриминационной, противозаконной или любой другой информации, которая может составлять или приводить к действиям, которые могут рассматриваться как уголовно наказуемые, нарушающие права любой стороны или которые могут иным способом служить источником уголовно-правовой ответственности или нарушать какой-либо другой закон. За нарушение настоящего правила наступает ответственность, предусмотренная нормами гражданского, административного и уголовного законодательства Российской Федерации, а также нормами международного права по охране интеллектуальной собственности. Администрация Платформы вправе в любое время без уведомления пользователя блокировать, удалять информацию, указанную выше и передавать информацию о таких фактах в правоохранительные и иные уполномоченные органы.
				</li>
			</ul>

			<p className='mt-3'>
				«18» апреля 2025 г. Юридический адрес и реквизиты владельца и правообладателя
				Платформы ООО «ГИР СТОР»
				<br />
				Юридический адрес: 601443, Владимирская область, Вязниковский р-н, г Вязники,
				<br />
				ул. Ленина, стр. 46
				<br />
				ИНН 3300013334
				<br />
				ОГРН 1243300005079
				<br />
				<br />
				Адрес электронной почты:{' '}
				<a className='link' href={`mailto:${SUPPORT_EMAIL}`}>
					{SUPPORT_EMAIL}
				</a>
			</p>
		</div>
	)
}

export default RulesForSellers
